import { Box, Image, VStack, HStack, Text, Icon, Center, Link, Divider } from '@chakra-ui/react';
import { AiFillPhone } from 'react-icons/ai';
import { ImLocation2 } from 'react-icons/im';

import NotOperate from '~/assets/images/not-operate.png';

import { useTranslation } from 'react-i18next';

type ServiceShutdownNoticeProps = {
  phoneNumber: string;
  address: string;
  storeId: string;
};

// 系統停止營運後，取代菜單商品區塊的說明與店家聯絡方式
export default function ServiceShutdownNotice({
  phoneNumber,
  address,
  storeId,
}: ServiceShutdownNoticeProps) {
  const { t } = useTranslation();

  return (
    <Box pt={8}>
      <Center>
        <VStack spacing={2} py={4} maxW="420px">
          <Image src={NotOperate} w="full" />

          <Text fontSize="md" color="wsGray.500" textAlign="center">
            {t('store.shutdown.notice')}
          </Text>
          <Text fontSize="md" color="wsGray.800" textAlign="center" textDecoration='underline'>
            <Link
              href={`/${storeId}/orders`}
            >
              {t('store.shutdown.viewOrderStatus')}
            </Link>
          </Text>

          <Divider />

          <Text fontSize="md" color="wsGray.500" textAlign="center">
            {t('store.shutdown.notice2')}
          </Text>

          <VStack align="center" spacing={2}>
            <HStack align="center">
              <Icon as={AiFillPhone} color="wsGray.500" boxSize="1.125rem" />
              <Link fontSize="md" href={`tel:${phoneNumber}`} color='wsGray.800'>
                {phoneNumber}
              </Link>
            </HStack>

            <HStack align="center">
              <Icon as={ImLocation2} color="wsGray.500" boxSize="1.125rem" mt="0.15rem" />
              <Text fontSize="md" color='wsGray.800'>{address}</Text>
            </HStack>
          </VStack>
        </VStack>
      </Center>
    </Box>
  );
}
